export default {
  subQuestions: [],
  subQuestion: undefined,
};
